import { HeroCarouselInputs } from './HeroCarousel';

export const heroCarouselTransformer = (node): HeroCarouselInputs => {
    return {
        title: node.field_title,
        carouselSlideData: node.relationships?.field_carousel_images.map(
            (slide) => {
                return {
                    eyebrow: slide.field_eyebrow_text,
                    title: slide.field_title,
                    text: slide.field_body?.value,
                    ctas: slide.field_cta_link,
                    image: slide.relationships?.field_image?.relationships
                        ?.field_media_image_1?.localFile?.childImageSharp
                        ?.gatsbyImageData,
                    mobileImage:
                        slide.relationships?.field_image_mobile?.localFile
                            ?.childImageSharp.gatsbyImageData,
                    imageAlt:
                        slide.relationships?.field_image?.field_media_image_1
                            .alt,
                };
            }
        ),
    };
};
